//

import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import PrivateRouteAccess from './PrivateRoute_Access';

export default function PrivateRoute({ children, ...rest }) {
  const authenticated = useSelector((state) => state.users.authenticated);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        authenticated ? (
          <PrivateRouteAccess>{children}</PrivateRouteAccess>
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
